export interface CustomerDataModel {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  nationalId: string;
  employeeId: string;
  address: string;
  postalCode: string;
}

export class columnsModel {
  field: string;
  header: string;
  width: number;

  constructor() {
    this.field = '';
    this.header = '';
    this.width = 10;
  }
}

export class personData {
  userSessionId: string = '';
  customerSessionId: string = '';
  serviceName: string = '';
  urlPattern: string = '';
  apiVersion: string = '';
  clientId: string = '';
  refreshFlag:  boolean = false;
  componentName: string = '';
  globalIdentifierId: string = '';
  platformExternalId: string = '';
  platformInternalId: string = '';
  openAccountProcess: boolean = true;
  domain: string = '';
  layoutId: string = "";
  customerType: string = "";
  roleType: string = '';
  securityLevel: string = '0';
  planTypeList: any = [];
}

export interface CallCustomerAttributes {
  attributes: GEN_attributes

}
/**
 * https://alightdevelopmentandit.atlassian.net/browse/CCR3-9252 --- hasbroTestConfig:any='';udpTestConfig:any=''; added by @VamsiKrishna
*/
export class sAuthModel{
  SAuthStatus:boolean=false;
  remainingPswdAttempt:any;
  voicePinOnFile:any='';
  voicePinStatus:any='';
  personStatus:any='';
  hasbroTestConfig:any='';
  authsystemInstanceId:any='';
  authclientId:any='';
  udpTestConfig:any='';
  preAuthUserAPIFail:boolean=false;
  PINRESET:boolean=false;
  FTU:boolean=false;
  OTC:boolean=false;
  PIN: boolean=false;
  PINCNG:boolean=false;
  SQA: boolean=false;
  UAS: boolean=false;
  APE:boolean=false;
  IND_DATA: boolean=false;
  pswdResetDate:any;
  voicePinResetDate:any;
  userId:any='';
}

export class AaaSModel{
  
  remainingPswdAttempt:any;
  voicePinOnFile:any='';
  voicePinStatus:any='';
  personStatus:any='';
  AAASUserAPIFail:boolean=false;
  InternalServerError:boolean=false;
  PINRESET:boolean=false;
  FTU:boolean=false;
  OTC:boolean=false;
  PIN: boolean=false;
  PINCNG:boolean=false;
  SQA: boolean=false;
  UAS: boolean=false;
  APE:boolean=false;
  IND_DATA: boolean=false;
  pswdResetDate:any;
  voicePinResetDate:any;
  userId:any='';
  SAuthStatus:boolean=false;
  preAuthUserAPIFail:boolean=false;
}
export class GEN_attributes {
  IS_CS_CUSTOMER_ID_ENCRYPTED?: boolean = false;
  ENC_CS_CUSTOMER_ID?: string = '';
  CS_CLIENT_ID?: string = '';
  PINV?: string = '';
  UDP_GBL_ID?: string = '';
  CUSTOMER_TYPE?: any = '';
  CS_CALLER_TYPE?: any = ''; //added to transfer call from  Care Portal to CSPro
  ROLE_TYPE?: any = '';
  CP_APPROVED_EXCPTION_SECURED?: boolean = false;
  CP_INDICATIVE_DATA_SECURED?: boolean = false;
  QUEUE_NAME?: any = '';
  CS_AUTH_CD?: string = '';
  cimData?: string = 'N/A';
  CS_SECURITY_LEVEL?:string='';
  Config_DesktopIndicator?: string = '';
  "PPT-NAME"?: string = ''; //added by @VamsiKrishna
  EMP?: string = ''; //added by @VamsiKrishna
  
}

export class InteractionDTO {
  // _id: any;
  externalRefId?: string;
  clientId?: string;
  created?: string;
  system?: string;
  subject?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    //type?: string;
  };
  description?: string; //”Authorized user required info”
  details?: string; //”client partner”
  channel?: string; //"call",
  buckets: any;
  initiated?: string; //”inbound”
  begin?: any; //"2022-11-11 11:21:36",
  end?: any; //"2022-11-11 11:40:36",
  contact?: {
    id?: string;
    name?: string; //“name of primary customer”,
    type?: string;
    phoneNumber?: string; //“phoneNumber of primary customer”,
    emailAddress?: string; //“emailAddress of primary customer”,
    ipAddress?: any;
    role?: string;
  };
  delegate?: {
    name?: string; //“David Sablowski”,
    delegateId?: string; //“@42421”,
    phoneNumber?: string; //“18476177161“,
    emailAddress?: string; //“david.sablowski@alight.com“
    telephonyId?: string; //“Genesys user id"
  };
}

export class AngularLogObject {
  userId?: string;
  date?: string;
  timestamp?: string;
  clientID?: string;
  globalId?: string;
  usersessionId?: string;
  customersessionId?: string;
  loger?: string;
  level?: string;
  message?: string;
  action?: string;
  containerName?: string;
  applicationType?: string;
  agentId?: string
}
